
import { route } from '../../Routes/Route'


import Dashboard from '../../Assets/Icons/Dashboard'
import VenueIcon from 'Assets/Icons/VenueIcon'
import Faq from 'Assets/Icons/Faq'
import Inquiry from 'Assets/Icons/Inquiry'
import Cms from 'Assets/Icons/Cms'
import Transaction from 'Assets/Icons/Transaction'
import User from 'Assets/Icons/users'


export const sidebarConfig = [
  { Component: Dashboard, title: 'Dashboard', link: route.dashboard, color: '#884B9D', allowed: 'noRole' },
  { Component: VenueIcon , title: 'Venue Management', link: route.venue, color: '#884B9D' , allowed: 'noRole'},
  { Component: User, title: 'Users', link: route.users, color: '#884B9D' , allowed: 'noRole'},
  { Component: Transaction, title: 'View Transactions', link: route.transaction, color: '#884B9D' , allowed: 'noRole'},
  { Component: Inquiry, title: 'Inquiry Management', link: route.inquiry, color: '#884B9D' , allowed: 'noRole'},
  { Component: Faq, title: 'FAQ Management', link: route.faq, color: '#884B9D' , allowed: 'noRole'},
  { Component: Cms, title: 'CMS Management', link: route.cms, color: '#884B9D' , allowed: 'noRole'},
  
]

